//明珠互动
const postInteractionUrl = `/gateway/hc-serve/miniapi/wechatInteractiveRecord/add`;
//明珠互动
const myInteractionUrl = `/gateway/hc-serve/miniapi/wechatInteractiveRecord/mineList`;
// 查询用户是否签署领里公约
const signingOfContractDetailsUrl = `/gateway/hc-serve/miniapi/neighborhood/signing-of-contract-details`;
// 获取合约内容
const getNeighborhoodConventionUrl = `/gateway/hc-serve/miniapi/neighborhood/get-neighborhood-convention`;
// 签署领里公约
const signTheContractUrl = `/gateway/hc-serve/miniapi/neighborhood/sign-the-contract`;
// 反馈列表
const findFeedbackPageUrl = `/gateway/hc-serve/mini/feedback/findFeedbackPage`;
//反馈保存
const saveOrUpdateFeedbackUrl = `/gateway/hc-serve/mini/feedback/saveOrUpdateFeedback`;

// 测试第三方授权接口
const thirdTestUrl = `/gateway/jb-future/jbfuture/getCaseInfoByTicket`;
//预约详情
const myAppointDetailUrl = `/gateway/hc-serve/miniapi/reservation/placeOrderDetail`;
//取消预约
const cancelAppointUrl = `/gateway/hc-serve/miniapi/reservation/cancelOrder`;
export {
  findFeedbackPageUrl,
  saveOrUpdateFeedbackUrl,
  myAppointDetailUrl,
  cancelAppointUrl,
  postInteractionUrl,
  myInteractionUrl,
  signingOfContractDetailsUrl,
  getNeighborhoodConventionUrl,
  signTheContractUrl,
  thirdTestUrl,
};
